import { QuotationModel } from "./quotation.model";

export class QuotationVersionModel {
  quotationVersionId: number = 0;
  quotationId: number = 0;
  quotation: QuotationModel | null = null;
  consecutive: number = 0;
  dateVersion: Date = new Date;
  active: boolean = true;
  observation: string | null = null;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  isLastVersion: boolean = true;
}